import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Header } from '../../shared-components/header/header';
import { Sidebar } from '../../shared-components/side-bar/sidebar';
import { Tabs } from '@algoan/dashboard/utils';
import { theme as dashboardTheme } from '@algoan/dashboard/theme';
import { Footer } from '../../shared-components/footer/footer';

export enum LayoutTheme {
  WHITE = 'WHITE',
  ICE_BLUE = 'ICE_BLUE',
}

interface LayoutProps {
  selectedTab: Tabs;
  shouldAddDropdown?: boolean;
  theme: LayoutTheme;
}

export const Layout: React.FC<PropsWithChildren<LayoutProps>> = ({
  children,
  selectedTab,
  shouldAddDropdown,
  theme,
}) => {
  const layoutTheme = theme === LayoutTheme.WHITE ? dashboardTheme.white : dashboardTheme.iceBlue;

  return (
    <S.Container>
      <Header shouldAddDropdown={!!shouldAddDropdown} />
      <S.Content>
        <Sidebar selectedTab={selectedTab} />
        <S.Body backgroundColor={layoutTheme} isFlexStart={false}>
          {children}
          <S.Spacer />
          <Footer color={layoutTheme} />
        </S.Body>
      </S.Content>
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
    flex-grow: 1;
  `,
  Content: styled.div`
    display: flex;
    flex-grow: 1;
    position: relative;
  `,
  Body: styled.div<{ backgroundColor: string; isFlexStart: boolean }>`
    position: relative;
    background-color: ${({ backgroundColor }) => backgroundColor};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: ${({ isFlexStart }) => (isFlexStart ? 'flex-start' : 'center')};
    flex: 1;
    padding: 24px 32px;
    width: 100%;

    @media print {
      background-color: white;
    }
  `,
  Spacer: styled.div`
    padding: 3px;
  `,
};
